/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */
import React from 'react';
export default (function (_ref) {
  var size = _ref.size,
    primaryColor = _ref.primaryColor,
    secondaryColor = _ref.secondaryColor;
  return /*#__PURE__*/React.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 42 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
    fill: primaryColor
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7095_36507",
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "42",
    height: "48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
    fill: primaryColor
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7095_36507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.4463 11.0851C24.2842 11.0342 24.8953 6.66708 25.6794 5.05429C25.214 4.53564 24.9686 3.51338 25.2376 2.60969C23.3643 0.0930822 23.604 5.10354 23.7107 6.67045C24.36 5.84105 23.402 8.14889 23.6078 8.61284C23.6433 8.40279 22.9772 12.6138 24.0463 11.7228C24.1108 11.8796 24.6752 11.0305 24.4486 11.0876L24.4463 11.0851Z",
    fill: secondaryColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7749 9.62623C34.8599 8.67744 35.4555 8.03786 36.282 7.51077C36.7283 4.27819 32.9755 8.45022 32.0793 9.47383C32.0793 9.47383 30.4663 11.2367 30.5232 10.9755C30.0737 11.0089 27.0189 13.2024 28.5477 13.6027C29.1004 13.2848 29.7974 12.2938 30.2622 12.4522C31.3683 12.5512 33.3234 10.0611 34.7751 9.62147L34.7749 9.62623Z",
    fill: secondaryColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0248 20.0843C41.0507 18.2865 36.9152 18.5769 35.4287 18.1889C35.4287 18.1889 33.9085 17.7033 33.4188 17.8368C33.6396 17.9081 28.1592 16.5002 30.714 18.428C30.7975 18.4262 32.694 18.9166 32.694 18.9166C34.9809 20.2763 37.7615 20.3387 40.0272 20.0821L40.0248 20.0843Z",
    fill: secondaryColor
  })), /*#__PURE__*/React.createElement("path", {
    d: "M25.0381 28.0381C21.3544 31.7218 15.3562 31.7218 11.6681 28.0381C7.98437 24.3543 7.98437 18.3562 11.6681 14.6681C15.3519 10.9843 21.35 10.9843 25.0381 14.6681C28.7262 18.3518 28.7219 24.35 25.0381 28.0381ZM14.0744 17.0743C11.7162 19.4325 11.7162 23.2737 14.0744 25.6318C16.4325 27.99 20.2737 27.99 22.6319 25.6318C24.99 23.2737 24.99 19.4325 22.6319 17.0743C20.2737 14.7162 16.4325 14.7162 14.0744 17.0743Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9119 24.3962L21.4007 27.9075L29.5832 36.09L33.0944 32.5788L24.9119 24.3962Z",
    fill: "#101214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3981 27.9068L23.0519 29.5606C23.765 29.1537 24.4344 28.6462 25.0425 28.0381C25.6506 27.4299 26.1581 26.7606 26.565 26.0474L24.9112 24.3937L21.3981 27.9068Z",
    fill: primaryColor
  }));
});